module.exports = __webpack_public_path__ + "img/heel-strike-shoe.3902bd1e.svg";